import VerifiedIcon from "../../../public/images/icons/verified.svg";

export const VerificationStatusAlert = ({ verificationStatus }: any) => {
    return (
        <div className="bg-base-300 rounded-[24px] p-[20px] md:p-20">
            <h2 className="font-bold text-2xl md:text-5xl mb-6 md:leading-[44px] flex flex-row items-center justify-between md:justify-center md:gap-x-4">Content Creator Verification
                <VerifiedIcon className="w-8 h-8 md:w-12 md:h-12 flex-none" />
            </h2>
            
            <p className="font-bold text-center text-2xl my-8">{verificationStatus.toString()}</p>
        </div>
    )
}